import { GET } from "../../service/CRUDService";
import EntityConstants from "../../configs/EntityConstants";

export const GetProgrammeName = async (programmeParam) => {
  try {
    console.log("The programme code is:", programmeParam);
    const response = await GET(
      `${EntityConstants.GET_PROGRAMME_BATCH_NAME}?${programmeParam}`
    );
    if (response.status === 200) {
      const data = await response.json();
      return data.programme;
    } else {
      console.error("Error fetching programme name:", response.status);
      return null;
    }
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export const GetBatchName = async (batchParam) => {
  try {
    console.log("The batch code is:", batchParam);
    const response = await GET(
      `${EntityConstants.GET_PROGRAMME_BATCH_NAME}?${batchParam}`
    );
    if (response.status === 200) {
      const data = await response.json();
      return data.batch;
    } else {
      console.error("Error fetching batch name:", response.status);
      return null;
    }
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};
